import gql from 'graphql-tag'

export const DEPARTAMENTO_FRAGMENT = gql`
  fragment DepartamentoFragment on Departamento {
    id
    nome
    sigla
    assinatura
  }
`

export const DEPARTAMENTOS_CARGOS_USUARIOS_QUERY = gql`
  ${DEPARTAMENTO_FRAGMENT}
  query DepartamentosCargosUsuarios {
    departamentosCargosUsuarios {
      ...DepartamentoFragment
    }
  }
`

export const DEPARTAMENTOS_COMUNICADOS_QUERY = gql`
  ${DEPARTAMENTO_FRAGMENT}
  query DepartamentosComunicados {
    departamentosComunicados {
      ...DepartamentoFragment
    }
  }
`
